export const API_BASE_URL = 'https://cleverdomizil.ch/virtual_office/api/';
export const INVOICE_URL = 'https://cleverdomizil.ch/virtual_office/public/uploads/';

// export const API_BASE_URL = 'https://cleverdomizil_ch/virtual_office/api/';
// export const INVOICE_URL = 'https://cleverdomizil_ch/virtual_office/public/uploads/';